'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _reduxActions = require('redux-actions');

var _withMapperData = require('../components/withMapperData');

var _tree2 = require('../utils/tree');

var _actions = require('../actions');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.MASON_ADD_CALLBACK, function (state, action) {
  var _action$payload = action.payload,
      name = _action$payload.name,
      f = _action$payload.f,
      componentId = _action$payload.componentId;

  if (componentId) {
    var $operation = _lodash2.default.has(state.callbacks, componentId) ? '$merge' : '$set';
    return (0, _immutabilityHelper2.default)(state, {
      callbacks: _defineProperty({}, componentId, _defineProperty({}, $operation, _defineProperty({}, name, f)))
    });
  }

  return (0, _immutabilityHelper2.default)(state, {
    callbacks: {
      $merge: _defineProperty({}, name, f)
    }
  });
}), _defineProperty(_handleActions, _withMapperData.MASON_DATA_SUCCESS, function (state, action) {
  var payloads = _lodash2.default.isArray(action.payload) ? action.payload : [action.payload];
  var now = new Date();
  return _lodash2.default.reduce(payloads, function (result, payload) {
    var nextState = _extends({}, result); // es-lint won't let us param reassign


    var data = payload.data;
    var componentId = payload.componentId,
        datasourceId = payload.datasourceId,
        path = payload.path;

    var component = _lodash2.default.get(state.components, componentId);

    if (!_lodash2.default.has(state.projects, component.projectId + '.datasources.' + datasourceId)) {
      // defensive - if someone was not migrated from old array index id style, just silently skip
      return result;
    }

    var operation = '$set';
    var destinationPath = component.projectId + '.datasources.' + datasourceId + '.data';

    if (path) {
      // we're updating part of a datasource only
      destinationPath = destinationPath + '.' + path;
    }

    var destination = _lodash2.default.get(state.projects, destinationPath); // no matter what operation we update fetchedAt


    nextState = (0, _immutabilityHelper2.default)(nextState, {
      projects: _defineProperty({}, component.projectId, {
        datasources: _defineProperty({}, datasourceId, {
          $merge: {
            fetchedAt: now.getTime()
          }
        })
      })
    });

    if (payload.action === 'remove') {
      // we're removing - we could be splicing from an array or unsetting an object key
      if (_lodash2.default.isEmpty(destination)) {
        return nextState;
      }

      var dataToRemove = data;

      var _nextData = void 0;

      if (_lodash2.default.isArray(destination)) {
        var idx = _lodash2.default.findIndex(destination, function (value) {
          return _lodash2.default.has(dataToRemove, 'id') && _lodash2.default.isEqual(dataToRemove.id, _lodash2.default.get(value, 'id')) || _lodash2.default.isEqual(value, dataToRemove);
        });

        if (idx === -1) {
          return nextState;
        }

        _nextData = path ? _lodash2.default.setWith({}, path, {
          $splice: [[idx, 1]]
        }, Object) : {
          $splice: [[idx, 1]]
        };
      } else if (path) {
        var pathParts = _lodash2.default.split(path, '.');

        _nextData = pathParts.length > 1 ? _lodash2.default.setWith({}, _lodash2.default.initial(pathParts), {
          $unset: [_lodash2.default.last(pathParts)]
        }, Object) : {
          $unset: [path]
        };
      } else {
        _nextData = {
          $set: _lodash2.default.isPlainObject(destination) ? {} : null
        };
      }

      return (0, _immutabilityHelper2.default)(nextState, {
        projects: _defineProperty({}, component.projectId, {
          datasources: _defineProperty({}, datasourceId, {
            data: _nextData
          })
        })
      });
    } else if (payload.action === 'merge' && (_lodash2.default.isArray(destination) || _lodash2.default.isPlainObject(destination))) {
      // we can only merge into arrays and objects, not primitives obviously
      // in the event we're merging with existing data, things are a bit complex
      // we may be merging into an object or an array
      // any other destination we will abort
      if (!_lodash2.default.isArray(destination) && _lodash2.default.isArray(data)) {
        // we cannot merge an array into an object, abort
        return nextState;
      }

      if (_lodash2.default.isArray(destination) && !_lodash2.default.isArray(data)) {
        // wrap data in an array to use $push below
        data = [data];
      }

      operation = _lodash2.default.isArray(data) ? '$push' : '$merge'; // same rules apply if it's an array
    }

    var nextData = path ? _lodash2.default.setWith({}, path, _defineProperty({}, operation, data), Object) : _defineProperty({}, operation, data);
    return (0, _immutabilityHelper2.default)(nextState, {
      projects: _defineProperty({}, component.projectId, {
        datasources: _defineProperty({}, datasourceId, {
          data: nextData
        })
      })
    });
  }, state);
}), _defineProperty(_handleActions, _actions.MASON_FETCH_COMPONENTS_SUCCESS, function (state, action) {
  return (0, _immutabilityHelper2.default)(state, {
    $merge: {
      blacklistedIds: action.payload.blacklistedIds,
      components: _lodash2.default.mapValues(_lodash2.default.keyBy(action.payload.components, 'id'), function (component) {
        return (0, _immutabilityHelper2.default)(component, {
          config: {
            data: _lodash2.default.mapValues(component.config.data, function (page, name) {
              return {
                tree: function tree(_tree) {
                  return (0, _tree2.hydrateTree)(_tree, component.config, name);
                }
              };
            })
          }
        });
      }),
      didInit: true,
      error: null,
      projects: _lodash2.default.keyBy(action.payload.projects, 'id')
    }
  });
}), _defineProperty(_handleActions, _actions.MASON_FETCH_STYLESHEETS_REQUEST, function (state) {
  return (0, _immutabilityHelper2.default)(state, {
    isLoadingStylesheets: {
      $set: true
    }
  });
}), _defineProperty(_handleActions, _actions.MASON_FETCH_STYLESHEETS_SUCCESS, function (state) {
  return (0, _immutabilityHelper2.default)(state, {
    isLoadingStylesheets: {
      $set: false
    }
  });
}), _defineProperty(_handleActions, _actions.MASON_FETCH_COMPONENTS_FAILURE, function (state, action) {
  return (0, _immutabilityHelper2.default)(state, {
    error: {
      $set: action.payload.error
    }
  });
}), _defineProperty(_handleActions, _actions.MASON_SET_OPTIONS, function (state, _ref2) {
  var payload = _ref2.payload;
  return (0, _immutabilityHelper2.default)(state, {
    $merge: payload
  });
}), _handleActions), {
  blacklistedIds: [],
  callbacks: {},
  components: {},
  data: {},
  didInit: false,
  draft: false,
  error: null,
  isLoadingStylesheets: false,
  projects: {},
  versionNumber: null
});